<script setup>
import { onMounted, computed, watch } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const store = useStore();

const props = defineProps({
  selectedTeam: {
    type: [Number, String],
    default: null,
  },
});

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agents = useMapGetter('agents/getAgents');

const agentLastSeen = computed(() => {
  return (
    store.getters['getAgentLastSeen'] ||
    store.state.overview?.agentLastSeen ||
    {}
  );
});

const fetchData = () => {
  const params = {};
  if (props.selectedTeam) {
    params.team_id = props.selectedTeam;
  }

  return store.dispatch('fetchAgentConversationMetric', params);
};

const selectedTeamAgentIds = computed(
  () => new Set(Object.keys(agentLastSeen.value).map(id => Number(id)))
);

const filteredAgents = computed(() => {
  if (!props.selectedTeam) {
    return agents.value;
  }

  return agents.value.filter(agent => selectedTeamAgentIds.value.has(agent.id));
});

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('agents/get');
  fetchData();
  startRefetching();
});

watch(
  () => props.selectedTeam,
  () => fetchData()
);
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')">
      <AgentTable
        :agents="filteredAgents"
        :agent-metrics="agentConversationMetric"
        :is-loading="uiFlags.isFetchingAgentConversationMetric"
        :agent-last-seen="agentLastSeen"
      />
    </MetricCard>
  </div>
</template>
